import { PagamentoWithDettaglioDTO } from '@framework/api-client';
import { assertNever } from '@framework/engine';
import { t } from '@framework/i18n';
import { Space, Tag, TagProps } from 'antd';
import styled, { DefaultTheme, useTheme } from 'styled-components';

const StyledTag = styled(Tag)`
  text-transform: uppercase;
  letter-spacing: 0.03em;
  line-height: 20px;
  padding-inline: 7px;
  &&& {
    font-weight: 600;
  }
`;

interface PaymentBurdenTypeTagsProps {
  payment: PagamentoWithDettaglioDTO;
}

type BurdenType = 'bollo' | 'oneri' | 'modello 1' | 'modello 3';

export function PaymentBurdenTypeTags(props: PaymentBurdenTypeTagsProps) {
  const { payment } = props;
  const burdenTypes = new Set<BurdenType>();

  // N.B. Oneri di tipo bollo non sono cumulabili con oneri di altro tipo
  payment.oneri?.forEach(o => {
    if (o.tipoOnere?.flPagamentoBollo) {
      burdenTypes.add('bollo');
    }
    if (o.tipoOnere?.flPagamentoModello1) {
      burdenTypes.add('oneri');
    }
    if (o.tipoOnere?.flPagamentoModello3) {
      burdenTypes.add('oneri');
    }
  });

  if (payment.preventivo?.tipoPagamento?.flPagamentoModello1) {
    burdenTypes.add('oneri');
  }
  if (payment.preventivo?.tipoPagamento?.flPagamentoModello3) {
    burdenTypes.add('oneri');
  }

  return (
    <Space>
      {Array.from(burdenTypes)
        .sort()
        .map(type => (
          <PaymentBurdenTypeTag key={type} type={type} />
        ))}
    </Space>
  );
}

interface PaymentBurdenTypeTagProps {
  type: BurdenType;
}

function PaymentBurdenTypeTag(props: PaymentBurdenTypeTagProps) {
  const { type } = props;
  const theme = useTheme();
  return <StyledTag {...getTagOptions(type, theme)} />;
}

function getTagOptions(type: BurdenType, theme?: DefaultTheme): TagProps {
  switch (type) {
    case 'bollo':
      return {
        color: theme?.colorInfo,
        children: t('payment-burden-type-tag.bollo', type),
      };
    case 'modello 1':
      return {
        color: theme?.colorSuccess,
        children: t('payment-burden-type-tag.modello-1', type),
      };
    case 'modello 3':
      return {
        color: theme?.colorSuccess,
        children: t('payment-burden-type-tag.modello-3', type),
      };
    case 'oneri':
      return {
        color: theme?.colorSuccess,
        children: t('payment-burden-type-tag.oneri', type),
      };
    default:
      assertNever(type);
  }
}
